// Next
import { GetServerSidePropsContext } from "next"

// Utils
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

// Layout
import MainLayout from "src/layouts/mainLayout"

// Components
import ClubList from "src/components/pages/club"

// ---------------------------------------|| CLUB - PAGES ||----------------------------------------------

const Club = () => {
  return <ClubList />
}

Club.Layout = MainLayout

export default Club

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
